


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// // Models
import { Budget } from '@/manager/budget/models/budget.model';
import { BudgetLine } from '@/manager/budget/models/budget-line.model';
import { TypeOfProduct } from '@/manager/product/models/product.model.ts';

// Components
import Field from '@/shared/components/field.component.vue';
import Input, { InputType } from '@/shared/components/input.component.vue';

// Views
import ShoppingCartLineBudget from '@/manager/budget/views/edit-budget-modal/shopping-cart/shopping-cart-line/index.vue';


@Component({
    components: {
        Field,
        Input,
        ShoppingCartLineBudget,
    },
    methods: {
        ...mapActions({
            fetchProductList: 'fetchProductList',
        }),
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            budget: 'getCurrentBudget',
        }),
    },
})
export default class ShoppingCartBudget extends Vue {
    @Prop({ default: false }) private modifyDataPrivate!: boolean;
    private fetchProductList!: any;
    private budget!: any;
    private inputType = InputType;


    private created() {
        this.fetchAllProductList();
    }


    get budgetAmountPaid() {
        let total = 0;
        total = (this.budget as any).budgetLine.reduce(
            (total: number, line: any) => {
                if ( line.totalPrepaidPrice ) {
                    return total + line.totalPrepaidPrice;
                } else {
                    return total;
                }
            },
            0,
        );
        total -= Number(this.budget.discountReservation);
        this.budget.totalPrice = total;
        return total;
    }

    get budgetTotal() {
        let total = 0;
        total = (this.budget as any).budgetLine.reduce(
            (total: number, line: any) => {
                if ( line.pricingApplied ) {
                    return total + (line.pricingApplied * line.amount);
                } else if ( line.totalPricingApplied ) {
                    return total + line.totalPricingApplied;
                } else {
                    return total;
                }
            },
            0,
        );
        this.budget.totalPrice = total;
        return total;
    }

    get budgetPending() {
        let total = 0;
        total = (this.budget as any).budgetLine.reduce(
            (total: number, line: any) => {
                if ( line.totalPrice ) {
                    return total + line.totalPrice;
                } else {
                    return total;
                }
            },
            0,
        );
        total += Number(this.budget.discountReservation);
        total -= Number(this.budget.discountSoonPayment);
        total -= Number(this.budget.discount);
        this.budget.totalPaymentPending = total;
        return total;
    }


    private fetchAllProductList(callback: any = () => { const a = 1; }) {
        this.fetchProductList({
            typeOfProduct: TypeOfProduct.Course,
        }).then((res: any) => {
            callback();
        });
    }

    private removeLine(line: BudgetLine) {
        const lines = (this.budget as any).budgetLine;
        const index = lines.indexOf(line);
        lines.splice(index, 1);
    }

    private newLine() {
        const newLine = new BudgetLine();
        (this.budget as any).budgetLine.push(newLine);
    }
}
